import { Form, Input, Select } from 'antd';
import * as Component from 'components';
import { ACTION_TITLE, CAST_TYPE_OPTIONS, DEFAULT_CAST_TYPE } from 'constants/constant';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { I18nFormFields } from '../../../../shared/components/i18n/I18nFormFields';
import { CastFormData, I18nFieldData } from '../../../../shared/types/i18n/i18nTypes';
import { slugify } from '../../../../shared/utils/slugify';
import { peopleService } from '../services/peopleService';

const PeopleAdd: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [i18nNameValue, setI18nNameValue] = useState<I18nFieldData>({});

  // i18n name 필드 변경 핸들러
  const handleI18nNameChange = (value: I18nFieldData) => {
    setI18nNameValue(value);

    // 레거시 필드와 실시간 동기화
    if (value.ko) {
      form.setFieldValue('name', value.ko);
    }
    if (value.en) {
      form.setFieldValue('name_en', value.en);
      // Auto-generate slug from English name
      const autoSlug = slugify(value.en);
      form.setFieldValue('slug', autoSlug);
    }
  };

  return (
    <Component.BasePageComponent>
      <div>
        <div className="people-details-page">
          <h1>People</h1>
          <Form form={form} layout="vertical" className="people-details-form">
            <I18nFormFields
              fieldName="name"
              required={true}
              fieldType="input"
              value={i18nNameValue}
              onChange={handleI18nNameChange}
              requiredLanguages={['en']}
              placeholder={{
                ko: '한국어 이름을 입력하세요',
                en: 'Enter name in English',
                'zh-hans': '请输入中文姓名',
                'zh-hant': '請輸入中文姓名',
              }}
            />
            <Form.Item
              name="slug"
              label="slug"
              rules={[{ required: true, message: 'Please enter slug' }]}
              normalize={value => slugify(value || '')}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="thumbnail"
              label="Thumbnail"
              valuePropName="file"
              getValueFromEvent={e => e?.target?.files?.[0]}
            >
              <input
                type="file"
                accept="image/*"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    const imageUrl = URL.createObjectURL(file);
                    setPreviewUrl(imageUrl);
                  }
                  if (e.target.files?.[0]) {
                    form.setFieldsValue({ thumbnail: e.target.files[0] });
                  }
                }}
              />
              {previewUrl && (
                <img
                  src={previewUrl}
                  alt="thumbnail preview"
                  style={{ maxWidth: '200px', marginTop: '10px' }}
                />
              )}
            </Form.Item>
            <Form.Item name="type" label="Type" initialValue={DEFAULT_CAST_TYPE}>
              <Select options={CAST_TYPE_OPTIONS} placeholder="Select cast type" allowClear />
            </Form.Item>
            <Form.Item name="birth_date" label="birth_date">
              <Input type="date" />
            </Form.Item>
            <Form.Item name="nationality" label="nationality">
              <Input />
            </Form.Item>
          </Form>
        </div>
        <div className="people-detail-update-button">
          <Component.ColorButtonComponent
            text={ACTION_TITLE.ADD}
            onClick={async () => {
              try {
                // 폼 검증
                await form.validateFields();

                // 현재 폼 데이터와 i18n 데이터 결합
                const formData = form.getFieldsValue();
                const castFormData: CastFormData = {
                  ...formData,
                  i18n_name: i18nNameValue,
                };

                // i18n 지원 서비스를 통해 생성
                await peopleService.createCastWithI18n(castFormData, navigate);
              } catch (error) {
                console.error('Failed to create people:', error);
              }
            }}
          />
        </div>
      </div>
    </Component.BasePageComponent>
  );
};

export default observer(PeopleAdd);
